module.exports = __webpack_public_path__ + "static/media/details-22-image-5.cc0ec35c.jpg";